<template>
  <footer class="footer">
    <div class="inner">
      <p class="footer__copy">
        Copyright (C) All Rights Reserved. ITOEN FOOD SERVICE CO.,LTD.
      </p>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@use '@/assets/scss/inc/_function' as *;
@use '@/assets/scss/inc/_mixin' as *;

.footer {
  min-height: var(--footer-height);
  padding-block: 0.8rem;
  background: var(--bg);
  @include flexCenter;

  &__copy {
    text-align: center;
    font-size: 0.8rem;
  }
}
</style>
